import { render, staticRenderFns } from "./BrbBtn.vue?vue&type=template&id=8fcd7d70&scoped=true&"
import script from "./BrbBtn.vue?vue&type=script&lang=js&"
export * from "./BrbBtn.vue?vue&type=script&lang=js&"
import style0 from "./BrbBtn.vue?vue&type=style&index=0&id=8fcd7d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcd7d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fcd7d70')) {
      api.createRecord('8fcd7d70', component.options)
    } else {
      api.reload('8fcd7d70', component.options)
    }
    module.hot.accept("./BrbBtn.vue?vue&type=template&id=8fcd7d70&scoped=true&", function () {
      api.rerender('8fcd7d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbBtn.vue"
export default component.exports